<template>
  <div class="bind-jd-pop" @click.stop>
    <section v-show="step === 1" class="pop-content">
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <header class="header">
        <div>
          <h3 class="title" @click="goToJdBindPage">
            绑定京东账号
          </h3>
          <p>完成以下步骤，绑定京东账户，完成商品上架</p>
        </div>
      </header>
      <section class="inner-content">
        <div class="guide-item">
          <p class="tip">
            1. 登录京东账号
          </p>
          <img class="image" src="../../assets/bind-jd-1.png" alt>
        </div>
        <div class="guide-item">
          <p class="tip">
            2. 填写达人信息
          </p>
          <img class="image" src="../../assets/bind-jd-2.png" alt>
        </div>
        <div class="guide-item">
          <p class="tip">
            3. 复制PID，返回粘贴
          </p>
          <img class="image" src="../../assets/bind-jd-3.png" alt>
        </div>
      </section>
      <footer class="footer">
        <el-button size="small" type="primary" @click="goToJdBindPage">
          去绑定京东账号
        </el-button>
        <el-button v-model="jdPid" type="weak" size="small" @click="step += 1">
          填写PID
        </el-button>
      </footer>
    </section>

    <section v-show="step === 2" class="pop-content">
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <header class="header">
        <div>
          <h3 class="title">
            暂未绑定京东账号
          </h3>
          <p>完成以下步骤，绑定京东账户，完成商品上架</p>
        </div>
      </header>
      <section class="inner-content">
        <div class="guide-item1">
          <div>
            <span>输入京东PID：</span>
            <qc-input v-model="jdPid" placeholder="xxxxxxxxxx_x_xxxxxxxxxx" />
            <div class="tip">
              <p>
                注意一个PID仅可使用一次；一个京东账号可申请多个PID。
                <qc-bubble placement="bottomLeft">
                  <span class="em">如何申请</span>
                  <template slot="popup">
                    <p>1. 点击去绑定“京东账号”</p>
                    <p>2. 点击“新增备案”</p>
                    <img class="multi-pid-img" src="../../assets/multi-pid.png" width="270" alt>
                  </template>
                </qc-bubble>
              </p>
            </div>
          </div>
        </div>
      </section>
      <footer class="footer">
        <el-button size="small" @click.stop="goToJdBindPage">
          去绑定京东账号
        </el-button>
        <el-button
          class="bindSaasPopBtn"
          data-compname="bindSaasPopBtn"
          data-saas_type="jd"
          @click="confirmBindJd"
          type="primary"
          size="small"
        >
          完成
        </el-button>
      </footer>
    </section>

    <section v-show="step === 3" class="pop-content1">
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>

      <div>
        <img src="../../assets/icon-success@2x.png" width="85" alt>
        <p class="tip">
          绑定成功
        </p>
        <p class="tip">
          全场京东联盟商品一键入库，赶紧去挑选吧
        </p>
        <div class="panel-wrap">
          <qc-button @click="hideSaasPop">
            去挑选
          </qc-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'BindJdPop',
  mixins: [commonMixin],
  data() {
    return {
      isClickJdBind: false,
      showBubble: false,
      jdPid: '',
      step: 1,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      bindSaasPop: state => state.common.bindSaasPop,
    }),
    ...mapGetters({
      isBindJd: 'userCenter/isBindJd',
      saasInfo: 'userCenter/saasInfo',
    }),
    jdBindUrl() {
      return this.getBindUrl('jd');
    },
  },
  methods: {
    getBindUrl(saasType) {
      const bindInfo = this.profile.saas_binding.filter(item => item && item.mask === saasType)[0];
      return bindInfo ? bindInfo.authenticate_entry : '';
    },
    goToJdBindPage() {
      if (!this.jdBindUrl) {
        this.$tip.error('京东绑定URL不存在');
        return;
      }

      if (this.step === 1) {
        this.step += 1;
      }

      window.open(this.jdBindUrl);
      this.isClickJdBind = true;
    },
    onClose() {
      console.log('close');
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
      this.$store.dispatch('common/checkNewGuide');
    },
    async confirmBindJd() {
      if (!this.jdPid) {
        this.$tip({
          message: 'jdPid不能为空',
          type: 'error',
        });

        return;
      }

      const reqPromise = this.bindJdPid(this.jdPid);
      reqPromise.then(async (res) => {
        if (res.code === 0) {
          await this.$store.dispatch('userCenter/fetchCpProfile');
          if (!this.isBindJd) {
            return;
          }

          this.step += 1;
        }
      });
    },
    hideSaasPop() {
      // this.$store.dispatch("common/checkNewGuide");
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;

.bind-jd-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.3);
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .pop-content {
    position: relative;
    width: 1000px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
        .image {
          height: 234px;
        }
        &:nth-child(3) {
          margin: 0 10px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
  .pop-content1 {
    position: relative;
    width: 500px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .tip {
      margin-top: 20px;
    }
    .panel-wrap {
      position: relative;
      top: 100px;
    }
  }
}
</style>
